import * as React from "react";
import { PersonExtended } from "./TypeExtensions";

export interface GlobalContextValue {
    loggedInUser: PersonExtended;
    selectedPilot: PersonExtended;

    selectedDate: string;

    setSelectedDate(newDate: string): void;

    /**
     * Suppose, that we updated a particular date like 8 Nov
     * but before that we had visited a date ahead of this, something like 10 Nov.
     * Because of this the data for 10 Nov is already saved in the cache.
     * 
     * Now, whenever the pilot duty for a 8 Nov(or any date before 10 Nov) is updated or deleted,
     * we need to clear the currency and duty times summary cache for all the dates
     * that are ahead of 8 Nov or else we will show stale values for the future dates
     * as apollo won't fetch again due to the presence of cache.
     * 
     * For this, we can saved the list of all the dates visited.
     * Now, when duty is updated for any date we can check and clear cache for all dates ahead of that date.
     */
    selectedDatesList: string[];
    setSelectedDatesList(addDate: string): void;

    setSelectedPilot(newPilot: PersonExtended): void;
    setLoggedInUser(user: PersonExtended | undefined): void;
}

export const GlobalContext = React.createContext<GlobalContextValue>({} as GlobalContextValue);
